// eslint-disable-next-line local-rules/no-disallowed-root-domains
export var PUBLIC_ASSETS = 'https://public-assets.typeform.com';
export var CDN_URL = 'https://d3m6p8tvnbsibq.cloudfront.net';